import { createStore } from 'vuex'
import publicOptions from '@/store/public/public'

export default createStore({
	modules: {
		publicOptions,
	}
})
